const ITEMS = [
  'Empowering',
  'Supporting',
  'Inclusive',
  'Registered NDIS Provider',
  'Mareeba & The Tablelands',
  'Supporting people to live fuller lives',
];

function Row({ ariaHidden }) {
  return (
    <div aria-hidden={ariaHidden} className="flex items-center gap-10 pr-10 shrink-0">
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center gap-10 shrink-0">
          <span className="font-display font-bold uppercase tracking-[0.28em] text-sm lg:text-base text-white/90 whitespace-nowrap">
            {item}
          </span>
          <svg width="14" height="14" viewBox="0 0 14 14" className="text-cyan-400 shrink-0" fill="currentColor">
            <path d="M7 0 L8.6 5.4 L14 7 L8.6 8.6 L7 14 L5.4 8.6 L0 7 L5.4 5.4 Z" />
          </svg>
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <section
      data-testid="marquee-band"
      className="marquee relative overflow-hidden bg-navy border-y border-white/10 py-5"
    >
      <div className="marquee-track flex w-max">
        <Row ariaHidden={false} />
        <Row ariaHidden={true} />
      </div>
    </section>
  );
}
